export default __webpack_public_path__ + "static/symple2-d1cd690876373c2c0d52e4e05d5668b2.jpg";